/**
 * Mounting helpers standing for Vue's v-if / v-for of the Experience components: a fragment is
 * a copy of a <template data-experience-template> of partials/experience/templates, inserted at
 * the place of its v-if (comment anchor <!--xp:name--> of the Blade markup) with the enter of
 * its <Transition name>, and removed after its leave, as Vue does.
 */
import { enter, leave } from "@/shared/transition";

export function fromTemplate(name: string): HTMLElement {
    const template = document.querySelector<HTMLTemplateElement>(`template[data-experience-template="${name}"]`);
    const element = template?.content.firstElementChild;
    if (!element) throw new Error(`experience: no template "${name}"`);
    return document.importNode(element, true) as HTMLElement;
}

/** Comment anchor <!--xp:name--> under `root`. */
export function anchor(root: Node, name: string): Comment {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_COMMENT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
        if ((node as Comment).data === `xp:${name}`) return node as Comment;
    }
    throw new Error(`experience: no anchor "${name}"`);
}

/** v-if becoming true inside <Transition :name> (enter classes set before the insertion). */
export function mountWithTransition(element: HTMLElement, place: Comment | HTMLElement, name: string): void {
    void enter(element, { name });
    if (place instanceof Comment) place.before(element);
    else place.append(element);
}

/** v-if becoming false inside <Transition :name>: removed once the leave is over. */
export function unmountWithTransition(element: HTMLElement, name: string): void {
    void leave(element, { name }).then(() => element.remove());
}

/** :class="{ name: value }" */
export function toggleClass(element: Element, name: string, value: boolean): void {
    if (element.classList.contains(name) !== value) element.classList.toggle(name, value);
}
